import type { MovimentoSaldoAntecipado } from '@/services/saldo-antecipado'
import { isCreditoSaldo, translateMotivoSaldo } from '@/services/saldo-antecipado'
import { formatDate, formatMoney } from '@/utils'
import { useTranslation } from 'react-i18next'
import './SaldoAntecipado.scss'

interface Props {
    item: MovimentoSaldoAntecipado
}

export default function SaldoAntecipadoItem({ item }: Props) {
    const { t } = useTranslation()
    const credito = isCreditoSaldo(item.Operacao)

    return (
        <article className="saldo-antecipado-item">
            <div className="saldo-antecipado-item-main">
                <div className="saldo-antecipado-item-title-row">
                    <h3 className="saldo-antecipado-item-motivo">{translateMotivoSaldo(item.Motivo, t)}</h3>
                    <span className={`saldo-antecipado-badge ${credito ? 'is-credito' : 'is-debito'}`}>
                        {credito ? t('Crédito') : t('Débito')}
                    </span>
                </div>
                <p className="saldo-antecipado-item-meta">
                    {t('Data')}: {item.Data ? formatDate(item.Data) : '—'}
                </p>
                {item.Limite ? (
                    <p className="saldo-antecipado-item-meta">
                        {t('Limite')}: {formatDate(item.Limite)}
                    </p>
                ) : null}
            </div>
            <strong className={`saldo-antecipado-item-valor ${credito ? 'is-credito' : 'is-debito'}`}>
                {credito ? '+' : '−'} {formatMoney(item.Valor)}
            </strong>
        </article>
    )
}
